import React from 'react';
import TaxServicesPackageGroup from './taxServices-package-group';

const individualPackages = [
	{
		label: 'Employment income or investment income only',
		price: 'LKR 17,000',
		name: 'Discussion of Personal tax matters with a CERTIFIED TAX ADVISOR',
		features: [
			'Personal tax Preparation Services',
			'Tax registration',
			'Tax advisory service',
			'Quarterly tax payments advices',
			'Tax Reminders on Tax due dates & Payment',
			'Preparation & Filing of Final Tax Return online',
			'Post Return filing support',
		],
	},
	{
		label: 'Employment income & investment income only',
		price: 'LKR 21,200',
		name: 'Discussion of Personal tax matters with a CERTIFIED TAX ADVISOR',
		features: [
			'Personal tax Preparation Services',
			'Tax registration',
			'Quarterly tax payments advices',
			'Tax Reminders on Tax due dates & Payment',
			'Advising & filing of Statement of Estimated Tax (SET)',
			'Preparation & Filing of Final Tax Return online',
			'Post Return filing support',
			'For timely & effective tax completion, it is advisable to submit your requirements in advance',
		],
	},
	{
		label: 'Investment income / employment income / business income (without financial statements)',
		price: 'LKR 25,400',
		name: 'Discussion of Personal tax matters with a CERTIFIED TAX ADVISOR',
		features: [
			'Personal tax Preparation Services',
			'Tax registration',
			'Tax advisory service',
			'Quarterly tax payments advices',
			'Tax Reminders on Tax due dates & Payment',
			'Advising & filing of Statement of Estimated Tax (SET)',
			'Preparation & Filing of Final Tax Return online',
			'Post Return filing support',
		],
	},
	{
		label: 'Investment income / employment income / business income with financial statements',
		price: 'LKR 33,900',
		name: 'Discussion of Personal tax matters with a CERTIFIED TAX ADVISOR',
		features: [
			'Personal tax Preparation Services',
			'Tax registration',
			'Tax advisory service',
			'Quarterly tax payments advices',
			'Tax Reminders on Tax due dates & Payment',
			'Advising & filing of Statement of Estimated Tax (SET)',
			'Preparation & Filing of Final Tax Return online',
			'Post Return filing support',
		],
	},
];

export default function IndividualConsultationPackages({ onRequest }) {
	return (
		<TaxServicesPackageGroup
			title="Individual Income Tax (IIT) consultation packages"
			packages={individualPackages}
			onRequest={onRequest}
		/>
	);
}